import HttpClient from "./http-client";
import { Cookies } from 'react-cookie';
import { LOGIN, FORGOT_PASSWORD, RESET_PASSWORD, IP_INFO, SIGN_UP, OTHER_INFO, USER_INFO, USD_TO_INR, CREATE_WALL, GET_UPDATED_EXTRA_DATA, LOGOUT, HOST_URL, CLOUD_URL, LIVE_API, GET_USER_INFO_FALLBACK, API_EVENT_DATE_UPDATE, GET_USERTAGS, MFA_VERIFY, MFA_SEND_EMAIL } from './api'
import { SIGN_UP_KEY, OTHER_SKIP, USER_TOKEN, USER_AUTHENTICATED_LOGIN, UPDATE_FIRST_RUN, GET_CURRENCY_USD_TO_INR, UPDATE_USER_TAGS, GET_TOP_AI_TAGS, TOP_AI_LOADER, IS_USER_INFO_UPDATING, UPDATE_COLLABRATOR_DATA } from '../reducers/keys'
import { updateCollabratorList } from "./collabratorAction";
import { TOAST_DISMISS, TOAST_ERROR, TOAST_LOADING, TOAST_SUCCESS, decrypt, encrypt, getInitialRoute, handleCatchError, setIntercomData, updateUserToken, withSkipOnboarding } from "../utils";
import store from "../store";
import { toggleAddFeedsSection } from "./show_modal_Action";
import { getWidgetWallData } from "./wallDataAction";
import { autoCompleteSearch } from "./moderationActions";

const cookies = new Cookies();

export const loginUser = (obj, redirectUrl, history, callback) => {
    return async (dispatch) => {
        await new HttpClient().post(LOGIN, obj).then((response) => {
            const { responseData, responseCode } = response.data;
            if (responseData?.is_mfa_enable) {
                localStorage.setItem('mfa_token', responseData.mfa_token);
                history('/mfa_auth');
            } else setUserData(responseData, responseCode, history, dispatch, obj, redirectUrl, callback)
        }).catch((ex) => {
            const { data } = ex.response;
            const { responseMessage } = data;
            callback(responseMessage)
        })
    }
}


export const mfaVerify = (obj, history, isCollabrator, updateSelectedCollabrator) => {
    return async (dispatch) => {
        await new HttpClient().post(MFA_VERIFY, obj).then((response) => {
            const { responseData, responseCode } = response.data;
            if (responseCode === 200) {
                if (isCollabrator) {
                    dispatch({ type: UPDATE_COLLABRATOR_DATA, payload: { data: responseData, id: responseData?.userId } });
                    updateSelectedCollabrator(responseData);
                    setTimeout(() => {
                        updateMfaCollaborator();
                    }, 100);
                } else {
                    localStorage.removeItem('mfa_token');
                    setUserData(responseData, responseCode, history, dispatch)
                }
            }
        }).catch(handleCatchError);
    }
}

const setUserData = (responseData, responseCode, history, dispatch, obj, redirectUrl, callback) => {
    let product = "display";
    if (responseData?.token) {
        dispatch({ type: USER_TOKEN, payload: responseData.token });
        dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: { ...responseData, countryCode: obj?.countryCode } });
        dispatch({ type: SIGN_UP_KEY, payload: { ...responseData, countryCode: (obj && Object.keys(obj).length > 0) ? obj?.countryCode : "US" } });
        const encryptedData = encrypt(JSON.stringify(responseData));
        localStorage.setItem('user_data', encryptedData);
        localStorage.setItem('authToken', responseData.token);
        const { user } = responseData;

        const allActiveProduct = String(responseData.activeProduct).split(',')
        const currentProduct = getCurrentActiveProduct(allActiveProduct, product);

        const isSocialWall = currentProduct != "widget" ? isSocialWallUser(responseData) : currentProduct;

        if (isSocialWall != 'widget') {

            if (user && user.failed_payment_strip_status !== 0) {
                localStorage.setItem('is_failed_payment', true);
            }

            if (user && Object.keys(user).length > 0) {
                let d = new Date();
                d.setTime(d.getTime() + (86400 * 30));
                cookies.set("memberLogin", true, { path: "/", expires: d, domain: '.taggbox.com' });
                cookies.set("memberUserId", user.id, { path: "/", expires: d, domain: '.taggbox.com' });

                localStorage.setItem('ownerId', user.ownerId)
                // localStorage.setItem('loginOwnerId', user.id);
                localStorage.setItem('loginOwnerId', user.userhashId)

                localStorage.setItem('isCollaborator', 0);

                if (user.collabratorList && user.collabratorList.length > 0) {
                    dispatch(updateCollabratorList(user.collabratorList));
                }
            }

            if (responseData.activeProduct == '0') {
                history("/onboarding")
                return;
            }

            updateUserToken();
            dispatch({ type: UPDATE_FIRST_RUN, payload: true });

            if (user.plan_exceed === 2 || responseCode == 201) {
                setTimeout(() => {
                    localStorage.setItem('plan_exceeded', true);
                    history(`/wall/extrawallfeeds`)
                }, 200);
            } else {
                if (redirectUrl) {
                    history(redirectUrl)
                } else {
                    if (responseData.access == 2) {
                        history('onboarding');
                    } else {

                        if (responseData.activeProduct) {
                            const isOnboarding = (responseData.user && Object.keys(responseData.user).length > 0 && !responseData.user.extra_data.includes('created_feed') && responseData.user.extra_data.includes('skip_onboarding') && JSON.parse(responseData.user.extra_data)["skip_onboarding"] == false);
                            const route = `/${isOnboarding ? 'onboarding' : 'walls/home'}`;
                            history(route, { replace: true });
                        }
                    }
                }
            }
        } else {
            callback('Couldn`t find your account with this e-mail')
        }
    }
}

export const logout = () => {
    return new HttpClient().post(LOGOUT)
}

export const forgotPassword = (data) => {
    return new HttpClient().post(FORGOT_PASSWORD, data)
}
export const resetPasswords = (data) => {
    return new HttpClient().post(RESET_PASSWORD, data)
}
export const getIPDetails = () => {
    return new HttpClient().get(IP_INFO)
}

export const userSignUp = (data, history, responseCallback, stopLoader) => {
    if (!(data && data.createFrom === 'signup')) {
        TOAST_LOADING();
    }

    let referenceId = '';
    let themeId = '';

    if (data['referenceId']) {
        referenceId = data['referenceId'];
        delete data['referenceId'];
    }
    if (data['themeId']) {
        themeId = data['themeId'];
        delete data['themeId'];
    }

    return async (dispatch) => {
        if (!(data && data.createFrom == 'signup')) {
            await getIPDetails().then((ipResponse) => {
                data = { ...data, countryCode: ipResponse.data.country };
            }).catch(ex => console.log(ex));
        }

        new HttpClient().post(SIGN_UP, data).then(async (resposne) => {
            const { responseData, responseCode } = resposne.data;
            if (responseData && Object.keys(responseData).length > 0) {

                // Website (micro-tool) se aaya user onboarding nahi dekhega. Ye redux / localStorage
                // me jaane se PEHLE set karna zaroori hai - warna neeche wala USER_AUTHENTICATED_LOGIN
                // purane extra_data ke saath jata hai, aur access_token set hote hi BasePage ka guard
                // /onboarding pe navigate kar deta hai (onboarding ki jhalak dikh jati hai).
                if (referenceId && responseData?.user && Object.keys(responseData.user).length > 0) {
                    responseData.user.extra_data = withSkipOnboarding(responseData.user.extra_data);
                    localStorage.setItem('isOnboarding', 1);
                }

                if (isSocialWallUser(responseData)) {
                    const encryptedData = encrypt(JSON.stringify(responseData));
                    localStorage.setItem('user_data', encryptedData);
                    if (responseData?.token) {
                        stopLoader();
                        dispatch({ type: USER_TOKEN, payload: responseData });
                        dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: { ...responseData, countryCode: data.countryCode } });
                        dispatch({ type: SIGN_UP_KEY, payload: { ...responseData, countryCode: (data && Object.keys(data).length > 0) ? data.countryCode : "US" } });
                        const { user, UserPlan } = responseData;

                        if (user && Object.keys(user).length > 0) {
                            if (user.collabratorList && user.collabratorList.length > 0) {
                                dispatch(updateCollabratorList(user.collabratorList))
                            }

                            localStorage.setItem('ownerId', user.ownerId)
                            localStorage.setItem('loginOwnerId', user.userhashId)
                            localStorage.setItem('isCollaborator', 0);

                            let d = new Date();
                            d.setTime(d.getTime() + (86400 * 30));
                            cookies.set("memberLogin", true, { path: "/", expires: d, domain: '.taggbox.com' });
                            cookies.set("memberUserId", user.id, { path: "/", expires: d, domain: '.taggbox.com' });
                        }

                        if (referenceId) {
                            localStorage.setItem('access_token', responseData.token);

                            // HttpClient zaroori hai - ownerId / loginOwnerId / isCollaborator / type
                            // headers aur socialWall flag ke bina createWall reject ho jati hai.
                            try {
                                const wallResponse = await new HttpClient().post(`${CREATE_WALL}`, { socialWall: 1, referenceId, themeId });
                                const wall = wallResponse?.data?.responseData;
                                const wallId = wall?.wallId;
                                if (wallId) {
                                    localStorage.setItem('wallId', wallId);
                                    if (responseData.user) responseData['user']['wallIdDesc'] = wallId;
                                    localStorage.setItem('user_data', encrypt(JSON.stringify(responseData)));
                                }
                            } catch (ex) {
                                // wall na bane to bhi signup complete hai - user ko atkana nahi hai
                                console.log("createWall failed :", ex?.response?.data?.responseMessage || ex?.message);
                            }

                            // skip_onboarding server pe bhi persist karo
                            dispatch(getUpdatedExtraData({ skip_onboarding: true }));
                        }
                        else {
                            localStorage.setItem('authToken', responseData.token);
                        }

                        if (UserPlan && UserPlan.displayAccess === 0) {
                            history(`/widget/product/switch/display`);
                        }
                        if (!(data && data.createFrom === 'signup')) {
                            setTimeout(() => {
                                TOAST_DISMISS();
                            }, 1000)
                        }

                        if (!(user && Object.keys(user).length > 0 && user.emailId.length > 0)) {
                            if (String(responseData.activeProduct).includes("0")) {
                                history("/accounts/extemail")
                            }
                            else if (String(responseData.activeProduct).includes("6")) {
                                history("/widget/accounts/extemail")
                            }
                            else if (String(responseData.activeProduct).includes("4")) {
                                history("/accounts/extemail")
                            }
                        } else {
                            const extraData = JSON.parse(user.extra_data) ? JSON.parse(user.extra_data) : {};
                            const isExistingUser = extraData && Object.keys(extraData).length > 0 ? extraData.hasOwnProperty("moderation") : false;
                            if (!isExistingUser) {
                                if (String(responseData.activeProduct).includes("0")) {
                                    history("/accounts/otherinfo")
                                }
                                else if (String(responseData.activeProduct).includes("6")) {
                                    history("/widget/accounts/otherinfo")
                                }
                                else if (String(responseData.activeProduct).includes("4")) {
                                    history("/accounts/otherinfo")
                                }
                            } else {
                                if (responseData.activeProduct == '0') {
                                    history("/onboarding")
                                    return;
                                }
                                updateUserToken();

                                if (user.plan_exceed === 2 || responseCode == 201) {
                                    dispatch({ type: UPDATE_FIRST_RUN, payload: true });
                                    setTimeout(() => {
                                        history(`/wall/extrawallfeeds`)
                                    }, 200);
                                } else {
                                    // sirf ek hi route chuno - pehle `if (referenceId) history(...)` ke
                                    // baad neeche wala history() bhi chal jata tha (double navigate),
                                    // aur website user onboarding pe pahunch jata tha.
                                    if (referenceId) {
                                        history('/walls/home', { replace: true });
                                    } else if (responseData?.access == 2) {
                                        history('/onboarding');
                                    } else {
                                        const isOnboarding = (responseData.user && Object.keys(responseData.user).length > 0 && !responseData.user.extra_data.includes('created_feed') && responseData.user.extra_data.includes('skip_onboarding') && JSON.parse(responseData.user.extra_data)["skip_onboarding"] == false);
                                        const route = `/${isOnboarding ? 'onboarding' : 'walls/home'}`;
                                        history(route, { replace: true });
                                    }
                                    // navigate ke baad hi bootstrap chalao - warna signup page pe hi
                                    // wall / feeds / notification / plan calls fire ho jati hain
                                    dispatch({ type: UPDATE_FIRST_RUN, payload: true });
                                }
                            }
                        }
                    } else {
                        if (responseData.activeProduct == "0") history("/accounts/otherinfo")
                        else if (responseData.activeProduct == "4") history(`/walls/home`);
                    }

                } else {
                    responseCallback({
                        "responseCode": 1,
                        "responseMessage": 'Couldn`t find your account with this e-mail',
                    })
                }
            }

        }).catch((ex) => {
            stopLoader();
            const { data, status } = ex?.response || {};
            if (!(data && data.createFrom === 'signup')) {
                setTimeout(() => {
                    TOAST_DISMISS();
                }, 1000)
                TOAST_ERROR(data?.responseMessage || data?.message || data?.response_message || "Something went wrong, please try again later.");
            }
            if (status == 401) {
                responseCallback(data)
            }
        })
    }
}

export const otherInfoSkip = (history, activeProduct, stopLoading) => {
    return (dispatch) => {
        if (stopLoading) stopLoading();
        dispatch({ type: OTHER_SKIP, payload: "init" });
        history("/onboarding");
    }
}

export const otherInfoUpate = (data, history, needRedirection) => {

    return (dispatch) => {
        updateOtherInfo(data).then((resposne) => {
            dispatch({ type: SIGN_UP_KEY, payload: { ...resposne.data, redirect: "init" } });
            dispatch(getUseronboardingInfo(() => history("/onboarding")))
        }).catch((ex) => {
            const { data } = ex.response;
            const { responseMessage } = data;
            console.log(responseMessage, "responseMessage")
        })
    }
}

export const updateOtherInfo = (data) => {
    return new HttpClient().post(OTHER_INFO, data);
}

// userInfo har call pe naya token issue karti hai aur purana invalid kar deti hai.
// Do calls parallel chal gayi to purane token wali baaki requests 419 de deti hain,
// isliye ek hi in-flight request sabko share karayi jaati hai.
let userInfoRequest = null;
let userInfoRequestType = null;
const requestUserInfo = (product) => {
    const type = product != 'widget' ? 4 : 6;
    // sirf same `type` wali call share karo - widget aur display ka response alag hota hai
    if (!userInfoRequest || userInfoRequestType !== type) {
        userInfoRequestType = type;
        userInfoRequest = new HttpClient().post(USER_INFO, { type });
        const clear = () => { userInfoRequest = null; userInfoRequestType = null; };
        userInfoRequest.then(clear, clear);
    }
    return userInfoRequest;
}

export const getUserInfo = (history, needRedirect = false, isTaggshopLogin = false, isApiCallRequired = false, callback = null) => {
    return async (dispatch) => {

        const product = getInitialRoute();
        dispatch({ type: IS_USER_INFO_UPDATING, payload: true });
        if (isApiCallRequired || (!localStorage.getItem('user_data') && !localStorage.getItem('Isadmin'))) {
            let data = {};

            await getIPDetails().then((ipResponse) => {
                data = ipResponse.data;
            }).catch(ex => console.log(ex));

            await requestUserInfo(product).then((response) => {
                const { responseData, responseCode } = response.data;
                if (responseData && Object.keys(responseData).length > 0) {
                    localStorage.setItem('access_token', responseData.token);
                    const encryptedData = encrypt(JSON.stringify(responseData));
                    localStorage.setItem('user_data', encryptedData);
                    if (callback) {
                        if (callback == 'isUpgrade') history(`/accounts/success`);
                        else callback();
                    }
                    if (responseData.token) {
                        dispatch({ type: USER_TOKEN, payload: responseData.token });
                        dispatch({ type: IS_USER_INFO_UPDATING, payload: false });
                        dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: { ...responseData, countryCode: (data && Object.keys(data).length > 0) ? data.country : "US" } });
                    }
                    setIntercomData(responseData?.Intercom);
                    const { user } = responseData;

                    if (user && Object.keys(user).length > 0) {

                        localStorage.setItem('loginOwnerId', user.userhashId)
                        let d = new Date();
                        d.setTime(d.getTime() + (86400 * 30));
                        cookies.set("memberLogin", true, { path: "/", expires: d, domain: '.taggbox.com' });
                        cookies.set("memberUserId", user.id, { path: "/", expires: d, domain: '.taggbox.com' });

                        if (user[`${'display'}expire`] === 1) history(`/accounts/expire`);
                        if (user[`${'display'}Access`] === 0) {
                            history(`/product/switch/${product != 'widget' ? isSocialWallUser(responseData) ? 'socialwalls' : 'display' : 'widget'}`);
                        }
                        if (user.collabratorList && user.collabratorList.length > 0) {
                            dispatch(updateCollabratorList(user.collabratorList));
                            const isCollaborator = localStorage.getItem('isCollaborator');

                            if (isCollaborator && isCollaborator == 1) {
                                const ownerId = localStorage.getItem('ownerId');
                                if (ownerId) {
                                    const filteredCollabrator = user.collabratorList.filter(collab => collab.userId == ownerId);
                                    if (filteredCollabrator.length > 0) {
                                        responseData['UserRule'] = filteredCollabrator[0]['UserRule'];
                                        responseData['UserPlan'] = filteredCollabrator[0]['UserPlan'];
                                        dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: { ...responseData } });
                                        const encryptedData = encrypt(JSON.stringify(responseData));
                                        localStorage.setItem('user_data', encryptedData);
                                    }
                                }
                            } else {
                                const encryptedData = encrypt(JSON.stringify(responseData));
                                localStorage.setItem('user_data', encryptedData);
                            }
                            if (callback) callback(user.collabratorList[1])
                        }
                        if (user.adminId) {
                            localStorage.setItem('adminId', user.adminId);
                        }

                        if (isTaggshopLogin) {
                            localStorage.setItem('ownerId', user.ownerId)
                            // localStorage.setItem('loginOwnerId', user.id);
                            localStorage.setItem('userhashId', user.userhashId)
                            localStorage.setItem('isCollaborator', 0);
                        }
                    }

                    if (user.plan_exceed === 2 || responseCode == 201) {
                        localStorage.setItem('plan_exceeded', true);
                        history(`/wall/extrawallfeeds`)
                    } else {
                        localStorage.removeItem('plan_exceeded');
                        if (needRedirect) history(`/walls/home`);
                    }
                }
            }).catch((ex) => {
                const { data } = ex.response;
                const { responseMessage } = data;
                console.log("response", responseMessage)
            })
        } else {

            try {
                const decryptData = decrypt(localStorage.getItem("user_data"));
                const user_data = JSON.parse(decryptData);

                if (localStorage.getItem("user_data") && user_data) {
                    const active_product = user_data.activeProduct.length > 1 ? user_data.activeProduct.split(',') : [user_data.activeProduct]
                    if (user_data && Object.keys(user_data).length > 0) {

                        if (user_data.token) {
                            dispatch({ type: USER_TOKEN, payload: user_data.token });
                            dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: { ...user_data } });
                        }

                        if (user_data.user.emailId != 'ben.mahtani@pwcampbell.com' && !localStorage.getItem('Isadmin') && window.location.href.includes('app') && (user_data && user_data.Intercom && Object.keys(user_data.Intercom).length > 0)) {
                            let intercomSettings = { ...user_data.Intercom };
                            const selected_useCase = localStorage.getItem('selected_useCase');
                            if (selected_useCase) {
                                localStorage.removeItem('selected_useCase');
                                intercomSettings = { ...user_data.Intercom, onboardingCase: selected_useCase }
                            }
                            window.intercomSettings = intercomSettings;
                            if (cookies.get('emailConfirmation') == 'true') window.pendingIntercomSettings = intercomSettings;
                            else { window.Intercom('shutdown'); window.Intercom('boot', intercomSettings); }
                        }
                        const { user } = user_data;
                        if (user && Object.keys(user).length > 0) {

                            localStorage.setItem('loginOwnerId', user.userhashId)

                            if (user[`${getInitialRoute()}expire`] === 1) {
                                history(`/accounts/expire`);
                            }
                            if (user[`${getInitialRoute()}Access`] === 0) {
                                history(`/product/switch/${getInitialRoute() != "widget" ? isSocialWallUser(user_data) ? 'socialwalls' : 'display' : 'widget'}`);
                            }
                            if (user.collabratorList && user.collabratorList.length > 0) {
                                dispatch(updateCollabratorList(user.collabratorList))
                            }
                            if (user.plan_exceed === 2) {
                                history(`/wall/extrawallfeeds`);
                                localStorage.setItem('plan_exceeded', true);
                            } else {
                                localStorage.removeItem('plan_exceeded');
                            }
                            if (isTaggshopLogin) {
                                localStorage.setItem('ownerId', user.ownerId)
                                // localStorage.setItem('loginOwnerId', user.id);
                                localStorage.setItem('loginOwnerId', user.userhashId)
                                localStorage.setItem('isCollaborator', 0);
                            }
                        }
                        if (needRedirect) {
                            if (active_product.find(product => product == "0")) history("widget", `/widget/walls/home`);
                            else if (active_product.find(product => product == "6")) history(`/walls/home`);
                            else if (active_product.find(product => product == "4")) history(`/walls/home`);
                        }
                    }
                } else {
                    if (!['accounts/verifyemail', 'redirectlogin', 'confirmaccount'].some(el => window.location.pathname.includes(el))) {
                        localStorage.clear();
                        history("/accounts/login")
                    }
                }
            } catch (ex) {
                if (!['accounts/verifyemail', 'redirectlogin', 'confirmaccount'].some(el => window.location.pathname.includes(el))) {
                    localStorage.clear();
                    history("/accounts/login")
                }
            }

        }
    }
}


export const getUpdatedExtraData = (data = {}, callBack = () => { }) => {
    return async (dispatch) => {
        new HttpClient().post(GET_UPDATED_EXTRA_DATA, data).then((response) => {
            const { responseData } = response.data
            if (responseData && Object.keys(responseData).length > 0) {
                const { userData } = store.getState().authenticated;
                if (userData && Object.keys(userData).length > 0) {
                    let data = { ...userData };
                    data['user']['extra_data'] = responseData.userData;
                    if (data && Object.keys(data).length > 0) {
                        const encryptedData = encrypt(JSON.stringify(data));
                        localStorage.setItem('user_data', encryptedData);
                        callBack();
                        if (data.token) {
                            dispatch({ type: USER_TOKEN, payload: data.token });
                            dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: { ...data } });
                        }
                    }
                }
            }
        }).catch((ex) => {
            const { responseMessage } = ex?.response?.data || {};
            console.log("response", responseMessage || ex?.message)
        })
    }
}

export const logOutUser = (logoutAdmin = false) => {

    cookies.remove("memberLogin", { path: "/", domain: '.socialwalls.com' });
    cookies.remove("memberUserId", { path: "/", domain: '.socialwalls.com' });

    logout().then(res => {
        let logOutRoute = `${HOST_URL}/accounts/logout`;
        if (logoutAdmin) {
            const adminId = localStorage.getItem('adminId');
            if (!adminId) logOutRoute = `https://${LIVE_API ? 'admin.socialwalls' : 'test.taggbox'}.com${LIVE_API ? "" : "/socialwalls-admin"}/users`;
            else logOutRoute = `https://${LIVE_API ? 'admin.socialwalls' : 'test.taggbox'}.com${LIVE_API ? "" : "/socialwalls-admin"}/users/userLogin/${adminId}`;
        }
        localStorage.clear();
        window.location.href = logOutRoute;
    }).catch(res => {
        localStorage.clear();
        window.location.href = `${HOST_URL}/accounts/logout`;
    })
};

export const checkLoginToken = (responseData) => {
    const { data } = responseData.response
    if (data && Object.keys(data).length > 0 && data.tokenExpired) {
        localStorage.clear()
        setTimeout(() => window.location.reload(), 200)
    }
}

export function getCurrentActiveProduct(allActiveProduct, product) {
    const { userData } = store.getState().authenticated;
    const switchProduct = product != 'widget' ? isSocialWallUser(userData) ? '' : 'display' : 'widget';

    if (allActiveProduct.includes("0") && !allActiveProduct.includes("4") && !allActiveProduct.includes("6")) return "widget";
    else if (allActiveProduct.includes("4") && allActiveProduct.includes("6")) return switchProduct;
    else if (allActiveProduct.includes("4") && !allActiveProduct.includes("6")) return isSocialWallUser(userData) ? '' : 'display';
    else if (!allActiveProduct.includes("4") && allActiveProduct.includes("6")) return "widget";
    else return "widget";
}

export function newUserAddFeedRedirection(wallId, navigate, dispatch) {
    dispatch(getWidgetWallData(localStorage.getItem('ownerId'), wallId));
    dispatch(toggleAddFeedsSection(true, `/widget/wall/index/${wallId}`, navigate));
}


export const getUserTags = (ownerId, wallId = 0,) => {
    const wallID = wallId ? wallId : localStorage.getItem('wallId')
    if (!LIVE_API) return () => { };
    return async (dispatch) => {
        dispatch({ type: TOP_AI_LOADER, payload: true })
        new HttpClient().get(`${GET_USERTAGS}/${wallID}`).then((response) => {
            const { responseCode, responseData } = response.data;


            if (responseData?.data && responseData?.data.length) {
                dispatch({ type: UPDATE_USER_TAGS, payload: responseData?.data?.map?.(item => item[0])?.join(",") ?? "" });
                dispatch({ type: GET_TOP_AI_TAGS, payload: responseData?.data, });
            } else {
                getTagsByAutoComplete(dispatch);
            }

            dispatch({ type: TOP_AI_LOADER, payload: false });
        }).catch(ex => {
            getTagsByAutoComplete(dispatch);
            dispatch({ type: TOP_AI_LOADER, payload: false })
        });
    }
}

const getTagsByAutoComplete = (dispatch) => {
    autoCompleteSearch("").then((response) => {
        const { status, tags } = response.data;
        if (status) {
            const allTags = tags.join(',');
            dispatch({ type: UPDATE_USER_TAGS, payload: allTags });
        }
    }).catch(ex => {

    })
}

export const getLanguageTags = (ownerId) => {

    const wallId = localStorage.getItem('wallId')
    const url = !LIVE_API ? `${CLOUD_URL}test/widgetDisplay/media/${ownerId}/${wallId}/language_${ownerId}.json` : `https://cloud.socialwalls.com/media/${ownerId}/${wallId}/language_${ownerId}.json`;
    return new HttpClient().get(`${url}?v=${(new Date() * 1000)}`);
}

export const getFlags = () => {
    const url = `https://cloud.tagbox.com/ugc-suite/app/json/languages.json`;
    return new HttpClient().get(`${url}?v=${(new Date() * 1000)}`);
}

export const isSocialWallUser = (userData) => {
    let newRoute = true;
    if (userData && Object.keys(userData).length > 0) {
        const { user, UserPlan } = userData;
        newRoute = user.lastThemeStatus ? true : false;
        if (UserPlan && Object.keys(UserPlan).length > 0 && UserPlan.planId) {
            newRoute = user.lastThemeStatus ? true : UserPlan.planId.includes("58") ? false : true;
        }
    }
    return newRoute;
}

export const updateAddFeedKey = () => {
    if (!localStorage.getItem('Isadmin') && window.location.host.includes("app")) {
        const decryptData = decrypt(localStorage.getItem("user_data"));
        const userData = JSON.parse(decryptData);
        if (window.Intercom && userData && userData.user && Object.keys(userData.user).length > 0) {
            const extraData = JSON.parse(userData.user.extra_data) ? JSON.parse(userData.user.extra_data) : {};
            if (extraData.created_feed) {
                if (!userData.Intercom.addFeed) {
                    let data = { ...userData };
                    data['intercomSettings'] = { ...userData.Intercom, addFeed: true };
                    if (data && Object.keys(data).length > 0) {
                        const encryptedData = encrypt(JSON.stringify(data));
                        localStorage.setItem('user_data', encryptedData);
                        window.intercomSettings = data.intercomSettings;
                    }
                    window.Intercom('boot', data.intercomSettings);
                }
            }
        }
    }
}


export const updateMfaCollaborator = () => {
    const { collabratorList } = store.getState()?.collabratorSection;
    const decryptedData = decrypt(localStorage.getItem("user_data"));
    const userData = JSON.parse(decryptedData);

    if (!userData?.user?.collabratorList || userData.user.addCollaborator) return;

    const data = { ...userData, user: { ...userData.user, collabratorList } };

    if (Object.keys(data).length > 0) {
        const encryptedData = encrypt(JSON.stringify(data));
        localStorage.setItem('user_data', encryptedData);
    }
};
//fallback to get token and user details
export const getUseronboardingInfo = (callback, beforeVerify, redirectURL = null) => {

    return (dispatch) => {
        new HttpClient().get(GET_USER_INFO_FALLBACK).then(response => {

            const { responseData: apiData } = response.data;
            setTimeout(() => {
                // the API can send back only a refreshed token (no `user`) - merge it into the stored user data instead of replacing it, otherwise the user (wallIdDesc, extra_data, ...) is wiped
                let responseData = apiData || {};
                if (!responseData.user) {
                    let storedData = null;
                    try { storedData = JSON.parse(decrypt(localStorage.getItem('user_data'))); } catch (ex) { }
                    storedData = storedData?.user ? storedData : store.getState().authenticated.userData;
                    if (storedData?.user) responseData = { ...storedData, ...responseData };
                }
                if (responseData && Object.keys(responseData).length > 0) {
                    if (responseData.token) {
                        localStorage.setItem(beforeVerify ? 'authToken' : 'access_token', responseData.token);
                        // getToken() (http-client) sends access_token whenever it exists - refresh it too, otherwise every later request keeps going out with the old token
                        if (beforeVerify && localStorage.getItem('access_token')) localStorage.setItem('access_token', responseData.token);
                    }
                    const encryptedData = encrypt(JSON.stringify(responseData));
                    localStorage.setItem('user_data', encryptedData);
                }
                if (responseData.token) {
                    dispatch({ type: USER_TOKEN, payload: responseData.token });
                    dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: responseData });
                    if (beforeVerify) dispatch({ type: SIGN_UP_KEY, payload: { ...responseData, countryCode: (responseData.user && responseData.user.country_code) ? responseData.user.country_code : "US" } });
                }
                const { user } = responseData;
                if (user && Object.keys(user).length > 0) {
                    localStorage.setItem('ownerId', user.ownerId)
                    // localStorage.setItem('loginOwnerId', user.id);
                    localStorage.setItem('loginOwnerId', user.userhashId)
                    localStorage.setItem('isCollaborator', 0);
                }
                setIntercomData(responseData?.Intercom);

                if (callback) callback()
                else redirectURL?.(beforeVerify, responseData.user?.access ?? responseData.access);

            }, redirectURL && typeof redirectURL == 'function' ? 3000 : 0)
        }).catch(ex => {
        })
    }
}


export const eventUpdate = (data = null) => {
    return new HttpClient().post(API_EVENT_DATE_UPDATE, data)
}

export const sendMfaCode = (payload) => {
    return new HttpClient().post(MFA_SEND_EMAIL, payload).then(response => {
        const { responseCode, responseMessage } = response.data;
        if (responseCode === 200) {
            TOAST_SUCCESS(responseMessage);
        }
    }).catch(handleCatchError)
}
